import React from "react";
import Layout from "../components/Layout";
import { graphql, Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import useResolveBlogText from "../hooks/useResolveBlogText";
import useResolveStrapiBlogText from "../hooks/useResolveStrapiBlogText";
import { useEffect } from "react";
import BlogCallToAction from "../components/BlogCallToAction";
import ArrowIcon from "../components/ArrowIcon";
import BlogCards from "../components/BlogCards";
import TextReveal from "../components/TextReveal";
import Seo from "../components/Seo";
import PopupBanner from "../components/PopupBanner/PopupBanner";
import linkedinIcon from "../images/linkedin.svg";

const BlogDetail = ({ data, location }) => {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Article",
        "@id": `https://datakulture.com/blog/${data.strapiBlog.slug}/#article`,

        mainEntityOfPage: {
          "@type": "WebPage",

          "@id": `https://datakulture.com/blog/${data.strapiBlog.slug}/`,

          url: `https://datakulture.com/blog/${data.strapiBlog.slug}/`,

          isPartOf: {
            "@type": "WebSite",

            "@id": "https://datakulture.com/#website",

            name: "Your big leap forward the data-driven way",

            url: "https://datakulture.com/",

            description:
              "Datakulture delivers untapped insights and actionable intelligence for growing businesses.",
          },
        },

        headline: `${data.strapiBlog.title}`,

        image: `https://datakulture.com/${data.strapiBlog.image.localFile.publicURL}`,

        author: {
          "@type": "Person",

          name: `${data.strapiBlog.author}`,
        },

        publisher: {
          "@type": "Organization",

          "@id": "https://datakulture.com/#organization",

          name: "datakulture",

          logo: {
            "@type": "ImageObject",

            url: "data:image/svg+xml;base64,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",
          },
        },

        datePublished: `${data.strapiBlog.publishedAt}`,

        dateModified: `${data.strapiBlog.updatedAt}`,
      },
      {
        "@context": "https://schema.org/",

        "@type": "BreadcrumbList",

        itemListElement: [
          {
            "@type": "ListItem",

            position: 1,

            name: "Homepage",

            item: "https://datakulture.com/",
          },
          {
            "@type": "ListItem",

            position: 2,

            name: "Blog",

            item: "https://datakulture.com/blog/",
          },
          {
            "@type": "ListItem",

            position: 3,

            name: `${data.strapiBlog.title}`,

            item: `https://datakulture.com/blog/${data.strapiBlog.slug}/`,
          },
        ],
      },
    ],
  };

  const filteredRelatedBlogs = data.allStrapiBlog.nodes.filter(
    (el) => el.slug !== location.pathname.split("/")[2],
  );
  const relatedBlogs = filteredRelatedBlogs.slice(0, 2);
  const content = useResolveStrapiBlogText(
    data.strapiBlog.BlogContent.data.BlogContent,
  );

  const renderLink = (description) => {
    if (!description) return null;
    const regex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/;
    const parts = description.split(regex);

    return parts.map((part, index) => {
      if (index % 3 === 0) {
        return <span key={index}>{part}</span>;
      } else if (index % 3 === 1) {
        const url = parts[index + 1];
        return (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-clr-blue"
            key={index}
          >
            {part}
          </a>
        );
      } else {
        return null;
      }
    });
  };

  useEffect(() => {
    document.querySelectorAll(".chapter").forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const targetId = this.getAttribute("href").substring(1); // Remove the leading '#'
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
          });
        }
      });
    });
    const leftChapters = document.querySelectorAll(".chapter");
    const rightColEl = document.querySelectorAll(".right-el");
    /******************Observer code *********/
    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          leftChapters.forEach((el) => {
            el.classList.remove("active");
            if (entry.target.textContent.trim() === el.textContent.trim()) {
              el.classList.add("active");
            }
          });
        }
      });
    });
    rightColEl.forEach((card) => observer.observe(card));
  }, []);

  return (
    <Layout location={location}>
      <Seo
        title={data.strapiBlog.metaTitle}
        description={data.strapiBlog.metaDescription}
        url={location.href}
        image={data.strapiBlog.image?.localFile?.publicURL}
        schemaMarkup={schema}
      />
      <PopupBanner />
      <section className="blog-detail-banner">
        <div className="container container--small-xl">
          <div className="blog-detail-banner__content">
            <div className="blog-detail-banner__text">
              <h1 className="text-h1 font--primary gap-2x text-fw-medium text-clr-primary">
                {data.strapiBlog.title}
              </h1>

              <p className="text-p2 gap-3x font--secondary text-clr-secondary text-fw-regular">
                {renderLink(data.strapiBlog.description)}
              </p>

              <div className="blog-detail-banner__date gap-7x-v2">
                <div className="blog-detail-banner__author gap-1x">
                  <div style={{ width: "40px" }}>
                    <GatsbyImage
                      image={
                        data.strapiBlog?.authorImage?.localFile?.childImageSharp
                          ?.gatsbyImageData
                      }
                      alt={data.strapiBlog?.title}
                    />
                  </div>
                  <p className="text-p2 font--secondary text-fw-medium text-clr-primary profile-adjust">
                    {data.strapiBlog.author}
                  </p>
                </div>
                <p className="text-p2 font--secondary text-clr-secondary text-fw-regular profile-adjust">
                  {data.strapiBlog.date}{" "}
                  <span className="date-separator"> |</span>
                </p>

                <p className="text-p2 font--secondary text-clr-secondary text-fw-regular profile-adjust">
                  {data.strapiBlog.ReadTime}
                </p>
              </div>
            </div>
            {/* <div className="blog-detail-banner__image-container">
              {data.strapiBlog.image?.localFile?.childImageSharp
                ?.gatsbyImageData ? (
                <GatsbyImage
                  image={
                    data?.strapiBlog?.image?.localFile?.childImageSharp
                      ?.gatsbyImageData
                  }
                  alt={data.strapiBlog.title}
                  className="img-w-100 gap-7x-v3 blog-detail-banner__image"
                />
              ) : (
                <img
                  src={data.strapiBlog.image?.localFile?.publicURL}
                  alt={data.strapiBlog?.title}
                  className="img-w-100 gap-7x-v3 blog-detail-banner__image"
                />
              )}
            </div> */}
            <div className="blog-detail-banner__image-container">
              {data?.strapiBlog?.videoBanner?.localFile?.publicURL ? (
                <video
                  className="img-w-100 gap-5x-v3 blog-detail-banner__video"
                  controls
                  controlsList="nodownload noplaybackrate"
                  disablePictureInPicture
                  playsInline
                >
                  <source
                    src={data.strapiBlog.videoBanner.localFile.publicURL}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              ) : data?.strapiBlog?.image?.localFile?.childImageSharp
                  ?.gatsbyImageData ? (
                <GatsbyImage
                  image={
                    data.strapiBlog.image.localFile.childImageSharp
                      .gatsbyImageData
                  }
                  alt={data.strapiBlog.title}
                  className="img-w-100 gap-7x-v3 blog-detail-banner__image"
                />
              ) : (
                <img
                  src={data?.strapiBlog?.image?.localFile?.publicURL}
                  alt={data?.strapiBlog?.title}
                  className="img-w-100 gap-7x-v3 blog-detail-banner__image"
                />
              )}
            </div>
          </div>
          <div className="gap-7x">{content}</div>
          <div className="blog-detail-content__authorDesc gap-7x">
            <div className="blog-detail-content__authorDesc-grid">
              <div className="blog-detail-content__authorDesc-grid__item"></div>
              <div className="blog-detail-content__authorDesc-grid__authorDetails">
                <div className="blog-detail-content__authorDesc-grid-right">
                  <div className="blog-detail-content__authorDesc-grid__authorblock flex flex-jc-sb">
                    <GatsbyImage
                      image={
                        data.strapiBlog?.authorImage?.localFile?.childImageSharp
                          ?.gatsbyImageData
                      }
                      alt={data.strapiBlog?.title}
                      style={{ height: "120px", width: "120px" }}
                      loading="lazy"
                    />
                    <div>
                      <p className="text-h4 font--secondary text-fw-medium text-clr-primary profile-adjust gap-05x">
                        by {data.strapiBlog.author}
                      </p>
                      <p className="text-p1 font--secondary text-fw-normal text-clr-primary gap-05x">
                        {data.strapiBlog.authorDescription ||
                          "Working at datakulture"}
                      </p>
                      {data.strapiBlog.linkedinProfileUrl && (
                        <a
                          href={data.strapiBlog.linkedinProfileUrl || ""}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={linkedinIcon}
                            alt={data.strapiBlog.author}
                          />
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="blog-detail-content__contact-grid__item"></div>
            </div>
          </div>
          <div className="blog-detail-content__contact">
            <div className="blog-detail-content__contact-grid">
              <div className="blog-detail-content__contact-grid__item"></div>
              <div className="blog-detail-content__contact-grid__item">
                {/* <BlogCallToAction
									title={data.strapiBlog.contactBlogText}
									btnText={data.strapiBlog.contactBlogButtonText}
									link={data.strapiBlog.ctaLinks}
								/> */}
              </div>
              <div className="blog-detail-content__contact-grid__item"></div>
              <div className="blog-detail-content__contact-grid__tags">
                <div className="text-h1 gap-4x text-fw-medium text-clr-primary font--primary">
                  Tags
                </div>
                <div className="blog-detail-content__contact-grid__tags-list">
                  {data.strapiBlog.tags &&
                    data.strapiBlog.tags.map((t, i) => (
                      <Link
                        className="text-p3 blog-detail-content__contact-grid__tags-list__item text-fw-medium  font--secondary"
                        to={`/blog/tag/${t.slug}`}
                        key={i}
                      >
                        {t.title}
                      </Link>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="related-blog">
        <div className="container container--large-l ">
          <div className="related-blog__header gap-6x">
            <h2 className="text-h2 text-fw-medium text-clr-primary">
              You may also like
            </h2>
            <div className="btn">
              <Link to="/blog" className="load-more-btn">
                All posts
                <ArrowIcon direction="right" theme="dark" btn />
              </Link>
            </div>
          </div>
          <BlogCards data={relatedBlogs} />
          <div className="mob-btn">
            <Link to="/blog" className="load-more-btn">
              All posts
              <ArrowIcon direction="right" theme="dark" btn />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};
export default BlogDetail;

export const query = graphql`
  query BlogDetailPageQuery($slug: String) {
    strapiBlog(slug: { eq: $slug }) {
      id
      title
      slug
      ReadTime
      author
      publishedAt(formatString: "DD-MM-YYYY")
      updatedAt(formatString: "DD-MM-YYYY")
      date
      description
      metaTitle
      metaDescription
      BlogContent {
        data {
          BlogContent
        }
      }
      image {
        localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              placeholder: BLURRED
              layout: CONSTRAINED
              formats: [NO_CHANGE]
            )
          }
          publicURL
          extension
        }
      }
      videoBanner {
        localFile {
          publicURL
          extension
        }
      }
      authorDescription
      linkedinProfileUrl
      authorImage {
        localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              placeholder: BLURRED
              layout: CONSTRAINED
              formats: [NO_CHANGE]
            )
          }
          publicURL
        }
      }
      tags {
        title
        slug
      }
      categories {
        title
        slug
      }
      BlogContent {
        data {
          BlogContent
        }
      }
      contactBlogText
      contactBlogButtonText
      ctaLinks
    }
    allStrapiBlog {
      nodes {
        title
        description
        BlogContent {
          data {
            BlogContent
          }
        }
        authorImage {
          localFile {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                width: 40
                placeholder: BLURRED
                layout: CONSTRAINED
                formats: [NO_CHANGE]
              )
            }
            publicURL
          }
        }
        image {
          localFile {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                placeholder: BLURRED
                layout: CONSTRAINED
                formats: [NO_CHANGE]
              )
            }
            publicURL
          }
        }
        categories {
          title
          slug
        }
        ReadTime
        featured
        author
        slug
      }
    }
  }
`;
